import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShoppingBag, X } from "lucide-react";
import { api, errMsg, LIBRO } from "@/lib/api";

const inp = "w-full border border-[#dcd5ce] bg-white px-4 py-3 text-sm outline-none focus:border-[#c5a059]";

export default function Tienda() {
  const [products, setProducts] = useState([]);
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState({ nombre: "", email: "", telefono: "", dni: "" });

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const comprar = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/orders", { ...form, product_id: sel.id });
      toast.success("Pedido registrado. Se abrirá WhatsApp para coordinar el envío.");
      setSel(null);
      setForm({ nombre: "", email: "", telefono: "", dni: "" });
      window.open(data.whatsapp_url, "_blank");
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div data-testid="tienda-page" className="mx-auto max-w-7xl px-6 py-24">
      <p className="label-xs">Tienda</p>
      <h1 className="mt-4 max-w-3xl text-5xl tracking-tight sm:text-6xl">Material psicopedagógico</h1>
      <p className="mt-6 max-w-2xl leading-relaxed text-[#4a4744]">
        Ebooks, guías, cuadernillos digitales y recursos de autoría propia. Al confirmar el pedido se coordina
        el pago y la entrega digital; luego el material queda disponible en la sección Mis compras del portal.
      </p>

      {products.length === 0 ? (
        <p className="mt-14 card-nilo p-10 text-sm text-[#5e5a56]" data-testid="tienda-empty">
          Muy pronto vas a encontrar acá los materiales disponibles.
        </p>
      ) : (
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {products.map((p) => (
            <div key={p.id} data-testid={`product-card-${p.id}`} className="card-nilo flex flex-col overflow-hidden">
              <div className="aspect-[4/3] overflow-hidden bg-[#f4f1ec]">
                <img src={p.imagen || LIBRO} alt={p.nombre} className="h-full w-full object-cover" />
              </div>
              <div className="flex flex-1 flex-col p-7">
                <span className="label-xs">{p.categoria}</span>
                <h2 className="mt-3 text-2xl leading-snug">{p.nombre}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-[#5e5a56]">{p.descripcion}</p>
                <p className="mt-5 serif text-3xl">${Number(p.precio).toLocaleString("es-AR")}</p>
                <button data-testid={`product-buy-${p.id}`} onClick={() => setSel(p)}
                  className="mt-5 btn-gold flex items-center justify-center gap-2 rounded-full px-6 py-3 text-xs font-semibold uppercase tracking-[0.18em]">
                  <ShoppingBag size={14} /> Comprar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {sel && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6" data-testid="order-modal">
          <form onSubmit={comprar} className="w-full max-w-md bg-white p-8">
            <div className="flex items-start justify-between">
              <div>
                <p className="label-xs">Pedido</p>
                <h2 className="serif text-2xl">{sel.nombre}</h2>
                <p className="mt-1 text-sm text-[#5e5a56]">${Number(sel.precio).toLocaleString("es-AR")}</p>
              </div>
              <button type="button" onClick={() => setSel(null)}><X size={18} /></button>
            </div>
            <div className="mt-6 space-y-3">
              <input data-testid="order-nombre" required placeholder="Nombre y apellido" className={inp} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} />
              <input data-testid="order-dni" placeholder="DNI (si tenés portal)" className={inp} value={form.dni} onChange={(e) => setForm({ ...form, dni: e.target.value })} />
              <input data-testid="order-email" placeholder="Email" className={inp} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input data-testid="order-telefono" placeholder="Teléfono / WhatsApp" className={inp} value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} />
            </div>
            <button data-testid="order-submit" className="mt-6 btn-gold w-full rounded-full px-8 py-3.5 text-xs font-semibold uppercase tracking-[0.18em]">
              Confirmar pedido por WhatsApp
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
